/* ============================================================
   Pholoh PDP size row — live stock urgency.
   Updates "Only N in stock" / "In stock" / "Sold out" when the shopper
   changes variant. Hooks the theme's own `variant:change` event
   (dispatched on document with detail.variant), and reads the per-variant
   inventory map embedded in the row by snippets/pholoh-size-row.liquid.
   ============================================================ */
(function () {
  'use strict';

  function mapFor(row) {
    var tag = row.querySelector('[data-pholoh-stock-map]');
    if (!tag) return {};
    try { return JSON.parse(tag.textContent || '{}'); } catch (e) { return {}; }
  }

  function paint(row, variantId) {
    var el = row.querySelector('[data-pholoh-stock]');
    if (!el) return;
    var th = parseInt(row.dataset.threshold, 10) || 10;
    var info = mapFor(row)[String(variantId)];

    el.classList.remove('is-low', 'is-out', 'is-hidden');
    if (!info || info.a === 0) {
      if (info) {
        // sold out -> red dot + "Out of stock" label
        el.textContent = 'Out of stock';
        el.classList.add('is-out');
      } else {
        el.textContent = 'In stock';
      }
      return;
    }
    if (info.m === 1 && info.q > 0 && info.q <= th) {
      el.textContent = 'Only ' + info.q + ' in stock';
      el.classList.add('is-low');
    } else {
      el.textContent = 'In stock';
    }
  }

  function paintTrustStock(variant) {
    var box = document.querySelector('[data-pholoh-instock]');
    if (!box) return;
    var inStock = !!variant.available;
    var dot = box.querySelector('[data-instock-dot]');
    var txt = box.querySelector('[data-instock-text]');
    if (dot) {
      dot.classList.toggle('is-in', inStock);
      dot.classList.toggle('is-out', !inStock);
    }
    if (txt) txt.textContent = inStock ? 'In stock — ready to ship (2–4 days)' : 'Out of stock';
  }

  function onVariant(variant) {
    if (!variant) return;
    document.querySelectorAll('[data-pholoh-sizerow]').forEach(function (row) {
      paint(row, variant.id);
    });
    paintTrustStock(variant);
  }

  function init() {
    // The theme dispatches this on document (bubbles) with detail.variant.
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) onVariant(e.detail.variant);
    });
    // Belt + suspenders: also catch the non-bubbling 'variantChange' via capture.
    document.addEventListener('variantChange', function (e) {
      if (e.detail && e.detail.variant) onVariant(e.detail.variant);
    }, true);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
